/*
 * Center header search bar with a typewriter placeholder.
 * Progressive enhancement: the <form> is a real search that submits to
 * /search with no JS. This only animates an aria-hidden overlay so the
 * animation never interferes with what the customer actually types.
 */
if (!customElements.get('search-typewriter')) {
  class SearchTypewriter extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.hsb__input');
      this.textEl = this.querySelector('.hsb__type-text');
      this.prefix = (this.dataset.prefix || 'Search for').trim();
      this.terms = (this.dataset.terms || '')
        .split(',')
        .map((term) => term.trim())
        .filter(Boolean);

      if (!this.input || !this.textEl || this.terms.length === 0) return;

      this.classList.add('is-ready');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.input.addEventListener('focus', () => this.activate());
      this.input.addEventListener('blur', () => {
        if (!this.input.value) this.deactivate();
      });
      this.input.addEventListener('input', () => {
        if (this.input.value) this.activate();
        else this.deactivate();
      });

      // Preserve any term the customer landed with (e.g. on /search results).
      if (this.input.value) {
        this.activate();
        return;
      }

      if (this.reduceMotion) {
        this.textEl.textContent = this.compose(this.terms[0]);
        return;
      }

      this.termIndex = 0;
      this.charCount = 0;
      this.deleting = false;
      this.paused = false;
      this.tick();
    }

    compose(term) {
      return this.prefix + ' "' + term + '"';
    }

    activate() {
      this.classList.add('is-active');
      this.paused = true;
    }

    deactivate() {
      this.classList.remove('is-active');
      if (this.reduceMotion) return;
      if (this.paused) {
        this.paused = false;
        this.tick();
      }
    }

    tick() {
      if (this.paused) return;

      const full = this.compose(this.terms[this.termIndex]);

      if (!this.deleting) {
        this.charCount += 1;
        this.textEl.textContent = full.slice(0, this.charCount);
        if (this.charCount >= full.length) {
          this.deleting = true;
          this.timer = setTimeout(() => this.tick(), 1700);
          return;
        }
        this.timer = setTimeout(() => this.tick(), 68);
      } else {
        this.charCount -= 1;
        this.textEl.textContent = full.slice(0, this.charCount);
        if (this.charCount <= 0) {
          this.deleting = false;
          this.termIndex = (this.termIndex + 1) % this.terms.length;
          this.timer = setTimeout(() => this.tick(), 340);
          return;
        }
        this.timer = setTimeout(() => this.tick(), 36);
      }
    }

    disconnectedCallback() {
      this.paused = true;
      clearTimeout(this.timer);
    }
  }

  customElements.define('search-typewriter', SearchTypewriter);
}
